import axiosInstance from '../shared/axiosInstance';
import { serviceConfig } from '../../config';
import { CeDealershipRespV1, GetDealershipQuery } from './types';

function useUrlQuery(dealershipQuery: GetDealershipQuery | undefined): string | undefined {
  if (dealershipQuery === undefined) {
    return undefined;
  }

  if (dealershipQuery.userId !== undefined && dealershipQuery.userId != '') {
    return `?userId=${dealershipQuery.userId}`;
  }
  if (dealershipQuery.email !== undefined && dealershipQuery.email != '') {
    return `?email=${dealershipQuery.email}`;
  }
  return undefined;
}

async function getOwnedDealerships(queryObject: GetDealershipQuery | undefined): Promise<CeDealershipRespV1> {
  if (queryObject === undefined) {
    throw new Error('Undefinedvalue');
  }
  const url = `${serviceConfig.endpoints.legacy.root}${
    serviceConfig.endpoints.legacy.dealerships
  }/owneddealershipsforuser${useUrlQuery(queryObject)}`;

  console.log('Complete url');
  console.log(url);
  let result = null;

  try {
    const response = await axiosInstance.get(url);
    result = response.data;
    console.log(result);
  } catch (err) {
    throw new Error('Error retriving the booking with the specified id');
  }

  return result;
}

export default getOwnedDealerships;
